(() => {
  if (window.__WN_COLLECTION_SEARCH__) return;
  window.__WN_COLLECTION_SEARCH__ = true;

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  function init(root) {
    if (!root || root.dataset.collectionSearchReady === 'true') return;
    const input = root.querySelector('[data-collection-search]');
    if (!input) return;
    root.dataset.collectionSearchReady = 'true';

    const cards = [...root.querySelectorAll('[data-collection-product]')];
    const editorials = [...root.querySelectorAll('[data-collection-editorial]')];
    const empty = root.querySelector('[data-collection-search-empty]');
    const status = root.querySelector('[data-collection-search-status]');
    const clears = [...root.querySelectorAll('[data-collection-search-clear]')];

    const params = new URLSearchParams(window.location.search);
    const initial = params.get('wn_q') || '';
    if (initial) input.value = initial;

    const apply = (syncUrl = true) => {
      const raw = input.value.trim();
      const query = normalize(raw);
      let visible = 0;

      cards.forEach((card) => {
        const matches = !query || normalize(card.dataset.searchText).includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      editorials.forEach((block) => { block.hidden = Boolean(query); });
      if (empty) empty.hidden = !query || visible > 0;
      clears.forEach((button) => { button.hidden = !raw; });

      if (status) {
        const label = visible === 1 ? root.dataset.resultSingle : root.dataset.resultPlural;
        status.textContent = query ? `${visible} ${label || ''}`.trim() : '';
      }

      if (syncUrl) {
        const url = new URL(window.location.href);
        if (raw) url.searchParams.set('wn_q', raw);
        else url.searchParams.delete('wn_q');
        history.replaceState({}, '', url);
      }
    };

    input.addEventListener('input', () => apply(true));
    input.addEventListener('search', () => apply(true));
    clears.forEach((button) => button.addEventListener('click', () => {
      input.value = '';
      apply(true);
      input.focus({ preventScroll: true });
    }));

    apply(false);
  }

  document.querySelectorAll('[data-collection-search-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-collection-search-root]').forEach(init);
  });
})();